var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topiDivider",class:_vm.disabled?'grey--text':'primary--text',style:({ 'border-bottom-color': this.$vuetify.theme.primary })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }